{
  "loading": "Laadimine...",
  "loadingMore": "Laadi rohkem..."
}
